import {GET_EVENT_LOOKS_SUCCESS} from '../actions/api'
import {
  ADD_LOOK,
  ADD_LOOK_ITEM,
  CLEAR_LOOK_PRODUCTS_TRANSACTION_TYPES,
  DELETE_LOOK,
  DELETE_LOOK_ITEM_SUCCESS,
  DISPLAY_NEXT_PRODUCT_GROUP,
  DISPLAY_PREV_PRODUCT_GROUP,
  EDIT_LOOK_NAME_SUCCESS,
  GET_PARTICIPANT_LOOK_SUCCESS,
  UPDATE_CURRENT_LOOKS,
  UPDATE_USER_EVENT_LOOK_ITEM_SUCCESS,
} from '../actions/looks'
import {CLEAR_CURRENT_EVENT} from '../actions/events'
import {getLookObjectIndex} from '../store/looks'

const initialState = []

function LooksException(message) {
  this.name = 'LooksException'
  this.message = message
}

export default function reducer(state = initialState, action) {
  let index
  let newState
  let products

  if (
    [
      ADD_LOOK_ITEM,
      DELETE_LOOK_ITEM_SUCCESS,
      DISPLAY_NEXT_PRODUCT_GROUP,
      DISPLAY_PREV_PRODUCT_GROUP,
      EDIT_LOOK_NAME_SUCCESS,
    ].includes(action.type)
  ) {
    if ([DELETE_LOOK_ITEM_SUCCESS, EDIT_LOOK_NAME_SUCCESS].includes(action.type)) {
      index = getLookObjectIndex(action.payload.lookId, state)
    } else {
      index = getLookObjectIndex(action.lookId, state)
    }
    if (index === -1) throw new LooksException(`look ${action.lookId} was not found`)
    newState = state.slice()
  }

  switch (action.type) {
    case ADD_LOOK:
      newState = state.slice()
      index = state.findIndex((look) => look.id === action.look.id)
      if (index >= 0) {
        newState[index] = action.look
      } else {
        newState.push(action.look)
      }
      break
    case ADD_LOOK_ITEM:
      newState[index] = Object.assign({}, newState[index], {products: action.newProducts})
      break
    case CLEAR_CURRENT_EVENT:
      // clear current event looks
      newState = []
      break
    case CLEAR_LOOK_PRODUCTS_TRANSACTION_TYPES:
      newState = state.map((look) => {
        if (look.id !== action.payload.lookId) {
          return look
        }
        return {
          ...look,
          products: look.products.map((product) =>
            Object.assign({}, product, {transactionType: ''}),
          ),
        }
      })
      break
    case DELETE_LOOK:
      newState = state.filter((look) => look.id !== action.lookId)
      if (newState.length === state.length) {
        throw new LooksException(`look ${action.lookId} was not found`)
      }
      break
    case DELETE_LOOK_ITEM_SUCCESS:
      products = newState[index].products.filter(
        (product) => product.id !== action.payload.lookItemId,
      )
      if (products.length === newState[index].products.length) {
        throw new LooksException(`look item ${action.payload.lookItemId} was not found`)
      }
      newState[index] = Object.assign({}, newState[index], {products})
      if (products.length % 6 === 0) {
        // this mean that visibleProductGroup needs to change
        newState[index].visibleProductGroup = 1
      }
      break
    case DISPLAY_NEXT_PRODUCT_GROUP:
      newState[index] = Object.assign({}, newState[index], {
        visibleProductGroup: newState[index].visibleProductGroup + 1,
      })
      break
    case DISPLAY_PREV_PRODUCT_GROUP:
      newState[index] = Object.assign({}, newState[index], {
        visibleProductGroup: newState[index].visibleProductGroup - 1,
      })
      break
    case EDIT_LOOK_NAME_SUCCESS:
      newState[index] = Object.assign({}, newState[index], {name: action.payload.lookName})
      break
    case GET_EVENT_LOOKS_SUCCESS:
      newState = action.payload.looks
      break
    case GET_PARTICIPANT_LOOK_SUCCESS:
      newState = action.payload
      break
    case UPDATE_CURRENT_LOOKS:
      newState = action.payload
      break
    case UPDATE_USER_EVENT_LOOK_ITEM_SUCCESS: {
      newState = state.map((look) => {
        // in case of multiple looks, return ones we don't need
        if (look.id !== action.payload.userEventLook) {
          return look
        }
        const newProducts = look.products.map((product) => {
          // return all products except the one being edited
          if (product.userEventLookItemId !== action.payload.id) {
            return product
          }
          return {
            ...product,
            transactionType: action.payload.transactionType,
          }
        })
        // bundle look back up with edited products
        return {
          ...look,
          products: newProducts,
        }
      })

      break
    }
    default:
      break
  }

  return newState || state
}
